import axios from "../../../../api/axios";

export interface UpdateServiceProfilePayload {
  overview: string;
}

export interface ServiceProfileResponse {
  data: {
    id: number;
    overview: string;
    rating: number;
    overallJobs: number;
    reviewsCount: number;
    userId: number;
  };
  message: string;
}

export const updateServiceProfile = async (
  userId: string,
  payload: UpdateServiceProfilePayload
): Promise<ServiceProfileResponse> => {
  try {
    const response = await axios.put<ServiceProfileResponse>(`/api/users/${userId}/service-profile`, payload);
    return response.data;
  } catch (err) {
    throw new Error(`Failed to update service profile: ${(err as Error).message}`);
  }
};
